import Select from '@components/Select';
import type { BaseComponentProps } from '@interfaces/selection';
import { useVideoInputs } from '@providers/DevicesProvider';
import { useLogger } from '@providers/LoggerProvider';
import { useMeetingManager } from '@providers/MeetingProvider';
import {
  useEffect,
  type ChangeEvent,
  type FC,
  type PropsWithChildren,
} from 'react';
import { Container } from './style';

interface CameraSelectionProps extends BaseComponentProps {
  /** The message that will be shown when no camera devices are found. */
  notFoundMsg?: string;
  /** The label that will be shown for camera selection, it defaults to "Camera source". */
  label?: string;
}

const CameraSelection: FC<PropsWithChildren<CameraSelectionProps>> = ({
  notFoundMsg = 'No camera devices found',
  label = 'Camera source',
  ...rest
}) => {
  const logger = useLogger();
  const { devices, selectedDevice } = useVideoInputs();
  const meetingManager = useMeetingManager();

  const handleSelect = async (
    e: ChangeEvent<HTMLSelectElement>,
  ): Promise<void> => {
    const deviceId = e.target.value;
    try {
      await meetingManager.startVideoInputDevice(deviceId);
    } catch (error) {
      logger.error('CameraSelection failed to select camera');
    }
  };

  useEffect(() => {
    meetingManager.startVideoInputDevice(selectedDevice as string);
  }, []);

  return (
    <Container {...rest}>
      <Select onChange={handleSelect}>
        {devices.map((device) => (
          <option value={device.deviceId} key={device.deviceId}>
            {device.label}
          </option>
        ))}
      </Select>
    </Container>
  );
};

export default CameraSelection;
